import application from 'application/application';

import 'select2';

application.directive('ngCustomSelectLazyLoad', [
	'$timeout',
	'API',
	'environment',
	($timeout, API, environment) => ({
		restrict: 'A',
		scope: {},
		link(scope, element, attributes) {
			$.fn.select2.defaults.set('language', {
				inputTooLong: args => {
					let overChars = args.input.length - args.maximum;

					return `Apague ${overChars} caracter${overChars > 1 ? 'es' : ''}`;
				},
				inputTooShort: args => {
					let remainingChars = args.minimum - args.input.length;

					return `Digite ${remainingChars} ou mais caracteres`;
				},
				maximumSelected: args => {
					const maximumSelection = args.maximum;

					return `Você só pode selecionar ${maximumSelection} ite${
						maximumSelection > 1 ? 'ns' : 'm'
					}`;
				},
				searching: () => 'Buscando…',
				removeAllItems: () => 'Remover todos os itens',
				noResults: () => 'Nenhum resultado encontrado',
				loadingMore: () => 'Carregando mais…',
				errorLoading: () => 'Os resultados não puderam ser carregados.'
			});

			let getCustomUrl = API[attributes.paths].paths[attributes.customUrl];

			let url = `https://dev-api.advise.com.br/core/v1/${getCustomUrl}`;

			if (environment.name === 'homologation')
				url = `https://homologacao-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (API.default.hostname.includes('sandbox-'))
				url = `https://sandbox-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (environment.name === 'production')
				url = `https://api.advise.com.br/core/v1/${getCustomUrl}`;

			const headers = localStorage.getItem('__authenticationToken__')
				? {
						Authorization:
							'Bearer ' + localStorage.getItem('__authenticationToken__')
				  }
				: {};

			const customSearch = attributes.ngCustomRegex
				? eval(`(${attributes.ngCustomRegex})`)
				: false;

			$(element)
				.select2({
					width: '100%',
					placeholder: attributes.placeholder,
					minimumInputLength: attributes.minimumLengthToSearch,
					dropdownParent:
						'ngSelectRelativeElement' in attributes
							? $(element).closest(
									attributes.ngSelectRelativeElement
										? attributes.ngSelectRelativeElement
										: 'body'
							  )
							: $(element).closest('.modal').length
							? $(element).closest('form')
							: '',
					containerCssClass: attributes.customSelectClass,
					dropdownCssClass: attributes.customDropClass,
					ajax: {
						delay: 250,
						url: url,
						headers: headers,
						data(params) {
							let object = {
								paginaAtual: params.page || 1,
								registrosPorPagina: 10
							};

							// let compara = isNaN(params.term);

							// if (compara == true) {
							// 	params.term = params.term.replace(/[.,\/\-_]/g, '');
							// }

							// if (compara == false) {
							object[attributes.ngSelectParam] = customSearch
								? customSearch(params.term)
								: params.term;
							// } else if (attributes.ngSelectParam) {
							// 	object[attributes.ngSelectParam] = params.term;
							// }

							object['paginaAtual'] = params.page || 1;

							if (
								attributes.ngSelectActive &&
								attributes.ngSelectActive != 'nomePalavraChave'
							)
								object['ativo'] = attributes.ngSelectActive;

							if (attributes.ngFields) object['Campos'] = attributes.ngFields;

							if (attributes.ngGroupId)
								object['IdGrupo'] = attributes.ngGroupId;

							if (attributes.ngGroupUserId)
								object['IdGrupoUsuarios'] = attributes.ngGroupUserId;

							if (attributes.ngTipoPasta)
								object['idTipoPasta'] = attributes.ngTipoPasta;

							return object;
						},
						processResults(data) {
							if (data.itens) {
								scope.resultsData = data.itens;

								return {
									results: scope.resultsData.map(item => {
										const results = {
											id: attributes.ngCustomValue
												? item[attributes.ngCustomValue]
												: item.idPalavraChave || item.id,
											text: attributes.ngCustomLabel
												? item[attributes.ngCustomLabel]
												: item.nomePasta || item.nome,
											value: attributes.ngCustomValue
												? item[attributes.ngCustomValue]
												: item.idPalavraChave || item.id
										};

										if (item.idProcesso) results.idProcesso = item.idProcesso;

										scope.results = results;

										return results;
									}),
									pagination: {
										more: data.itens.length === 10 ? true : false
									}
								};
							}
						}
					},
					templateResult: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					templateSelection: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					theme: attributes.customSelectTheme
				})

				.on('select2:open', () => {
					$('.select2-results__options').on('mousedown', e => {
						if (e.button == 1) return false;
					});

					// Foca automaticamente no input de busca
					setTimeout(() => {
						const searchField = document.querySelector(
							'.select2-container--open .select2-search__field'
						);

						if (searchField) {
							searchField.focus();
						}
					}, 0);
				})

				.on('select2:select', event =>
					$timeout(() => {
						if (scope.results.idProcesso) {
							const value = $(event.currentTarget)
								.find('option:selected')
								.val();

							scope.resultsData.map(item => {
								if (item.id == value) {
									$(element).attr('ng-custom-model', item.idProcesso);
									$(element).attr('ng-process-value', item.id);
								}
							});
						} else
							$(element).attr(
								'ng-custom-model',
								$(event.currentTarget)
									.find('option:selected')
									.val()
							);

						scope.$apply();
					})
				)

				.on('select2:opening', () =>
					$(window).on('resize.select2', () => $(element).select2('close'))
				)

				// Desatch resize event on close
				.on('select2:closing', () => $(window).off('resize.select2'));

			// Remover o title inicial.
			removeSelectionTitle(element);

			// Remover o title após alterações da seleção.
			$(element).on('change.removeSelectionTitle', () => {
				removeSelectionTitle(element);
			});

			scope.$watch('ngModel', (newValue, oldValue) => {
				const stringify = val =>
					typeof val === 'object' ? JSON.stringify(val) : val;

				if (stringify(newValue) == stringify(oldValue)) return;

				$timeout(() => {
					element.triggerHandler('change.select2');

					$(element).trigger('change');

					removeSelectionTitle(element);
				});
			});
		}
	})
]);

function customizeElement(el, elClass) {
	if ((el.element && el.element.classList[0]) != undefined) {
		let where = el.element.classList[0].slice(5);
		let span = document.createElement('span');
		let text = document.createTextNode(el.text);

		if (el.text.indexOf(where) > -1) span.classList.add(elClass);

		span.appendChild(text);

		return span;
	} else {
		return el.text;
	}
}

function removeSelectionTitle(element) {
	const select2 = $(element).data('select2');

	if (!select2) return;

	select2.$container.find('.select2-selection__rendered').removeAttr('title');
}
